const dispatchBookmarksChanged = () => {
  // Dispatch custom event to notify components about bookmark changes
  window.dispatchEvent(new CustomEvent('bookmarksChanged'));
};

export const getBookmarks = () => {
  try {
    const bookmarks = localStorage.getItem('coffee-bookmarks');
    return bookmarks ? JSON.parse(bookmarks) : [];
  } catch (error) {
    console.error('Error getting bookmarks:', error);
    return [];
  }
};

export const addBookmark = (product, categoryId) => {
  try {
    const bookmarks = getBookmarks();
    const bookmarkItem = {
      ...product,
      categoryId,
      bookmarkedAt: new Date().toISOString()
    };
    
    // Check if already bookmarked
    const isAlreadyBookmarked = bookmarks.some(item => 
      item.id === product.id && item.categoryId === categoryId
    );
    
    if (!isAlreadyBookmarked) {
      const updatedBookmarks = [...bookmarks, bookmarkItem];
      localStorage.setItem('coffee-bookmarks', JSON.stringify(updatedBookmarks));
      dispatchBookmarksChanged(); // Notify about change
      return true;
    }
    return false;
  } catch (error) {
    console.error('Error adding bookmark:', error);
    return false;
  }
};

export const removeBookmark = (productId, categoryId) => {
  try {
    const bookmarks = getBookmarks();
    const updatedBookmarks = bookmarks.filter(item => 
      !(item.id === productId && item.categoryId === categoryId)
    );
    localStorage.setItem('coffee-bookmarks', JSON.stringify(updatedBookmarks));
    
    // Dispatch two events to ensure all components update
    window.dispatchEvent(new CustomEvent('bookmarksChanged'));
    window.dispatchEvent(new CustomEvent('bookmarkRemoved', { 
      detail: { productId, categoryId } 
    }));
    
    return true;
  } catch (error) {
    console.error('Error removing bookmark:', error);
    return false;
  }
};

export const isBookmarked = (productId, categoryId) => {
  try {
    const bookmarks = getBookmarks();
    return bookmarks.some(item => 
      item.id === productId && item.categoryId === categoryId
    );
  } catch (error) {
    console.error('Error checking bookmark status:', error);
    return false;
  }
};

export const clearAllBookmarks = () => {
  try {
    localStorage.removeItem('coffee-bookmarks');
    dispatchBookmarksChanged(); // Notify about change
    return true;
  } catch (error) {
    console.error('Error clearing bookmarks:', error);
    return false;
  }
};